import React from 'react';
import TextBox from '../../../components/ui/TextBox';
import Button from '../../../components/ui/Button';

export type LoginViewProps = {
  username: string;
  password: string;
  loading: boolean;
  error: string | null;
  onUsernameChange: (v: string) => void;
  onPasswordChange: (v: string) => void;
  onSubmit: () => void;
};

export const LoginView: React.FC<LoginViewProps> = ({ username, password, loading, error, onUsernameChange, onPasswordChange, onSubmit }) => {
  const submit = (e: React.FormEvent) => { e.preventDefault(); onSubmit(); };
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-muted to-background">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <img src="/logo512.png" alt="VM Charm" className="mx-auto mb-2 h-12 w-12" />
          <div className="text-2xl font-bold">Welcome back</div>
          <div className="text-sm text-muted-foreground">Sign in to VM Charm Admin</div>
        </div>
        <form onSubmit={submit} className="rounded-xl border bg-card p-6 shadow-md">
          <div className="space-y-3">
            <TextBox
              type="text"
              label="Username"
              placeholder="your-username"
              value={username}
              onChange={e => onUsernameChange(e.target.value)}
              autoComplete="username"
              required
              disabled={loading}
            />
            <TextBox
              type="password"
              label="Password"
              placeholder="•••••••••"
              value={password}
              onChange={e => onPasswordChange(e.target.value)}
              autoComplete="current-password"
              required
              disabled={loading}
            />
          </div>
          {error && (
            <div className="mt-3 text-sm text-destructive" role="alert" aria-live="polite">{error}</div>
          )}
          <Button type="submit" className="mt-4 w-full" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
          <div className="mt-4 text-center text-xs text-muted-foreground">Use your admin credentials to continue</div>
        </form>
      </div>
    </div>
  );
};

export default LoginView;
